import { useEffect, useRef, useState } from 'react'
import './index.css'
import { useQueryParms } from '../../hooks/useQueryParams'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getAmoungVotes } from '../../utils/getAmoungVotes';

const MvpScreen = ()=>{
    const { pathname } = useQueryParms();
    const matchId = pathname?.split('/')?.[3]
    const [teams, setTeams] = useState({
        local:'',
        visitante:'',
        selected:'local',
        match: '',
        hasWinner: false,
    })
    const allVotes = getAmoungVotes(teams?.match?.mvp)
    const navigate = useNavigate();
    const matchesVoted = JSON.parse(localStorage.getItem('matchesVotedMvp')) || {}


    useEffect(()=>{
        if(!matchId) return
        const url = 'https://web-production-58ed.up.railway.app/api/get/jornadabyid'
        axios.get(url,{params:{_id: matchId}}).then(res =>{
            console.log('res', res)
            const[ golesLocal, golesVisitante]   = res?.data?.jornada?.resultado?.split('-');
            const localWon = golesLocal > golesVisitante
            const isdDrawn = golesLocal === golesVisitante
            setTeams(prev => ({...prev, ['local']: res.data?.jornada?.equipoLocal,
                ['visitante']: res.data?.jornada?.equipoVisitante, ['match']: res.data?.jornada,
                ['selected'] :  (localWon || isdDrawn) ? 'local' : 'visitante',
                ['hasWinner'] :  golesLocal !== golesVisitante
                
            }))
        }).catch(e => console.log('error', e))


    },[matchId])

    const handleSelectMvp = async  (jugador)=>{
                                const url = 'https://web-production-58ed.up.railway.app/api/vote/MvpPlayerByMatch';
                        try {
                             const matchInfo  = await axios.post(url, {matchId: matchId, playerId: jugador?.jugador?._id})
                             matchesVoted[matchId] = true
                             localStorage.setItem('matchesVotedMvp', JSON.stringify(matchesVoted))
                             navigate(-1)
                             

                            
                        } catch (error) {
                            console.log(error)
                        }


    }

    const renderListPlayer = ()=>{
        if(matchesVoted[matchId]) return<></>
        return (
            <div>
                <p style={{color:'rgb(231, 175, 87)'}}> Vota por el MVP del partido </p>

                 <div className='mvp-screen-list-player-section' >
                            {
                teams?.[teams.selected]?.jugadores?.map((jugador, i)=>(
                    <div onClick={()=> handleSelectMvp(jugador)} className='mvp-screen-item-player-section'>
                        <img  src={jugador?.jugador?.img} />
                        <p>{jugador?.jugador?.name}</p>
                    </div>
                ))
            }

            </div>

            </div>

        )

    }

    const renderMvpList = ()=>{
        if(teams?.match?.mvp?.length <= 0) return
        return (
            <div>
                <p style={{color:'rgb(231, 175, 87)'}}>MVP del partido</p>
            <div style={{color:'rgb(231, 175, 87)', display:'flex', justifyContent:'space-between', padding:'10px', fontWeight:'bold' }}>
                <p>Nº</p>
                <p>Nombre</p>
                <p></p>
                <p>Votos</p>
                
            </div>                             {
                                            teams?.match?.mvp?.map((player, i)=>{

                return            (
                <div style={{display:'flex', justifyContent:'space-between', color:'white',
                    borderBottom:'0.5px solid gold', padding:'10px'
                }}>
                    <p>{i + 1}</p>
                    <img width={50} src={player?.jugador?.img} />
                    <p>{player?.jugador?.name}</p>
                    <p>{((player.votos / allVotes)* 100).toFixed(1)} %</p>
                </div>
            )

            }

        )

                             }

            </div>


        ) 
    }
    return(<div className='mvp-screen-container' >
        <div className='mvp-screen-subcontainer'>
            <div className='mvp-screen-header'>
                {
                    ((teams?.hasWinner && teams?.selected === 'local') || !teams?.hasWinner  ) && (
                                        <div className={`mvp-screen-header-item-player ${teams?.selected === 'local' ? 'selected' : ''}`} onClick={()=> setTeams(prev => ({...prev, ['selected']: 'local'}))} >
                    <img  src={teams?.local?.pictureTeam} />
                    <p>{teams?.local?.name}</p>
                </div>

                    )
                }
                {
            ((teams?.hasWinner && teams?.selected === 'visitante') || !teams?.hasWinner  )  && (
                                 <div className={`mvp-screen-header-item-player ${teams?.selected !== 'local' ? 'selected' : ''}`}  onClick={()=> setTeams(prev => ({...prev, ['selected']: 'visitante'}))}  >
                    <img  src={teams?.visitante?.pictureTeam} />
                    <p>{teams?.visitante?.name}</p>
                </div>
            )               
            }



            </div> 
            {renderMvpList()}
            {renderListPlayer()}
        </div>

    </div>)
}

export default MvpScreen